/**
 * The palette's "Getting started" command, registered once for the whole app as soon as a
 * module imports this file (the Overview checklist does, and Overview is the first page).
 */
import { Rocket } from '@orgus/ui/icons';
import { registerCommands } from '../../lib/commands.ts';

let registered = false;

export function registerGettingStartedCommand(): void {
  if (registered) return;
  registered = true;
  registerCommands([
    {
      id: 'onboarding.open',
      title: 'Getting started',
      subtitle: 'Connect machines and repos, start a first mission, pick a notification channel',
      group: 'Navigation',
      icon: Rocket,
      keywords: ['onboarding', 'setup', 'welcome', 'checklist', 'phone', 'qr', 'first mission', 'templates', 'notifications', 'push'],
      order: 50,
      // React Router follows popstate, so this navigates without importing the router here.
      perform: () => {
        window.history.pushState(null, '', '/getting-started');
        window.dispatchEvent(new PopStateEvent('popstate'));
      },
    },
  ]);
}

registerGettingStartedCommand();
